import React, { ReactNode } from "react";
import { Image, View } from "@tarojs/components";
import classNames from "classnames";
import Button from "../Button";
import { XHComponentCommonProps } from "../../types";
import "./index.scss";

const ImageMap = {
  success: "https://s.xh1.cn/resources/images/public/success.png",
  empty: "https://s.xh1.cn/resources/images/public/empty.png",
  fail: "https://s.xh1.cn/resources/images/public/failure.png",
  networkErr: "https://s.xh1.cn/resources/images/public/error.png",
  wait: "https://s.xh1.cn/resources/images/public/ing.png",
  submitted: "https://s.xh1.cn/resources/images/public/success-info.png",
  faceEmpty: "https://s.xh1.cn/resources/images/public/faceEmpty.png",
};

export type ResultStatus = keyof typeof ImageMap;

export type ResultProps = {
  status: ResultStatus;
  title: ReactNode;
  desc?: ReactNode;
  slot?: ReactNode;
  action?: string;
  full?: boolean;
  onAction?: () => void;
} & XHComponentCommonProps;

const Result: React.FC<ResultProps> = props => {
  const {
    className,
    status,
    title,
    desc,
    slot,
    action,
    onAction,
    full = true,
  } = props;

  const resultCls = classNames("xh-result", className, { full });

  const renderImage = () => {
    if (process.env.TARO_ENV === "h5") {
      return <img src={ImageMap[status]} alt="" className="xh-result-status" />;
    } else {
      return <Image src={ImageMap[status]} className="xh-result-status" />;
    }
  };

  const handleAction = () => {
    onAction?.();
  };

  return (
    <View className={resultCls}>
      {renderImage()}
      <View className="xh-result-title">{title}</View>
      <View className="xh-result-desc">{desc}</View>
      <View className="xh-result-slot">{slot}</View>
      {action && (
        <View className={classNames("xh-result-action", { hasSlot: slot })}>
          <Button onClick={handleAction} hollow size="full">
            {action}
          </Button>
        </View>
      )}
    </View>
  );
};

export default Result;
